let getAccountId: (() => string | undefined) | undefined;

export const setAccountIdResolver = (resolver: () => string | undefined) => {
  getAccountId = resolver;
};

export const resolveAccountId = () => getAccountId?.();
